// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 全局样式 */

:root {
  /* 柠檬配色 */
  --lemon-50: #fefce8;
  --lemon-100: #fef9c3;
  --lemon-200: #fef08a;
  --lemon-300: #fde047;
  --lemon-400: #facc15;
  --lemon-500: #eab308;
  --lemon-600: #ca8a04;
  --lemon-700: #a16207;
  --lemon-800: #854d0e;
  --lemon-900: #713f12;

  /* 芒果配色 */
  --mango-50: #fff7ed;
  --mango-100: #ffedd5;
  --mango-200: #fed7aa;
  --mango-300: #fdba74;
  --mango-400: #fb923c;
  --mango-500: #f97316;
  --mango-600: #ea580c;
  --mango-700: #c2410c;
  --mango-800: #9a3412;
  --mango-900: #7c2d12;

  /* 绿叶素配色 */
  --leaf-50: #f0fdf4;
  --leaf-100: #dcfce7;
  --leaf-200: #bbf7d0;
  --leaf-300: #86efac;
  --leaf-400: #4ade80;
  --leaf-500: #22c55e;
  --leaf-600: #16a34a;
  --leaf-700: #15803d;
  --leaf-800: #166534;
  --leaf-900: #14532d;

  /* 中性色 */
  --gray-50: #f9fafb;
  --gray-100: #f3f4f6;
  --gray-200: #e5e7eb;
  --gray-300: #d1d5db;
  --gray-400: #9ca3af;
  --gray-500: #6b7280;
  --gray-600: #4b5563;
  --gray-700: #374151;
  --gray-800: #1f2937;
  --gray-900: #111827;

  /* 晶莹效果 */
  --crystal-bg: rgba(255, 255, 255, 0.1);
  --crystal-border: rgba(255, 255, 255, 0.2);
  --crystal-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  --crystal-backdrop: blur(20px);
  
  /* 渐变效果 */
  --gradient-primary: linear-gradient(135deg, var(--lemon-400), var(--mango-400));
  --gradient-secondary: linear-gradient(135deg, var(--leaf-400), var(--lemon-300));
  --gradient-success: linear-gradient(135deg, var(--leaf-500), var(--leaf-400));
  --gradient-danger: linear-gradient(135deg, #ef4444, #dc2626);
  
  /* 字体 */
  --font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  
  /* 阴影层级 */
  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.07);
  --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.1);
  --shadow-xl: 0 20px 25px rgba(0, 0, 0, 0.1);
  
  /* 动画时长 */
  --duration-fast: 0.15s;
  --duration-normal: 0.3s;
  --duration-slow: 0.5s;
}

/* 基础重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-size: 16px;
}

body {
  font-family: var(--font-family);
  font-weight: 400;
  line-height: 1.6;
  color: var(--gray-800);
  background: linear-gradient(135deg, var(--lemon-50), var(--mango-50), var(--leaf-50));
  min-height: 100vh;
  overflow-x: hidden;
}

/* 应用容器 */
.app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* 晶莹玻璃效果 */
.glass-card {
  background: var(--crystal-bg);
  backdrop-filter: var(--crystal-backdrop);
  -webkit-backdrop-filter: var(--crystal-backdrop);
  border: 1px solid var(--crystal-border);
  border-radius: 16px;
  box-shadow: var(--crystal-shadow);
  position: relative;
  overflow: hidden;
}

.glass-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
  z-index: 1;
}

/* 按钮样式 */
.crystal-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.875rem 1.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: all var(--duration-normal) ease;
  position: relative;
  overflow: hidden;
  text-decoration: none;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  font-family: var(--font-family);
}

.crystal-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left var(--duration-slow) ease;
  z-index: 1;
}

.crystal-btn:hover::before {
  left: 100%;
}

.crystal-btn > * {
  position: relative;
  z-index: 2;
}

.crystal-btn.primary {
  background: var(--gradient-primary);
  color: white;
  box-shadow: var(--shadow-md);
}

.crystal-btn.primary:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.crystal-btn.success {
  background: var(--gradient-success);
  color: white;
  box-shadow: var(--shadow-md);
}

.crystal-btn.success:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.crystal-btn.danger {
  background: var(--gradient-danger);
  color: white;
  box-shadow: var(--shadow-md);
}

.crystal-btn.danger:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.crystal-btn.large {
  padding: 1.25rem 2rem;
  font-size: 1.125rem;
  font-weight: 700;
}

.crystal-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: var(--shadow-sm) !important;
}

.crystal-btn:disabled::before {
  display: none;
}

/* 输入框样式 */
.crystal-input {
  width: 100%;
  padding: 0.875rem 1.125rem;
  background: rgba(255, 255, 255, 0.8);
  border: 2px solid var(--gray-200);
  border-radius: 12px;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--gray-800);
  transition: all var(--duration-normal) ease;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  font-family: var(--font-family);
}

.crystal-input:focus {
  outline: none;
  border-color: var(--lemon-400);
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 0 0 3px rgba(250, 204, 21, 0.1);
  transform: translateY(-1px);
}

.crystal-input::placeholder {
  color: var(--gray-500);
}

/* 水晶图标 */
.crystal-icon {
  font-size: 2rem;
  background: var(--gradient-primary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

.crystal-icon-large {
  font-size: 4rem;
  background: var(--gradient-secondary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
}

.crystal-icon-huge {
  font-size: 8rem;
  background: var(--gradient-primary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  filter: drop-shadow(0 8px 16px rgba(0, 0, 0, 0.1));
}

/* 动画 */
@keyframes fadeIn {
  0% { 
    opacity: 0; 
    transform: translateY(20px); 
  }
  100% { 
    opacity: 1; 
    transform: translateY(0); 
  }
}

@keyframes slideInUp {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0%, 100% { 
    opacity: 1; 
  }
  50% { 
    opacity: 0.5; 
  }
}

.fade-in {
  animation: fadeIn var(--duration-normal) ease;
}

.slide-in-up {
  animation: slideInUp var(--duration-normal) ease;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .crystal-btn {
    padding: 0.75rem 1.25rem;
    font-size: 0.8125rem;
  }
  
  .crystal-btn.large {
    padding: 1rem 1.5rem;
    font-size: 1rem;
  }
  
  .crystal-input {
    padding: 0.75rem 1rem;
    font-size: 0.8125rem;
  }
}

@media (max-width: 480px) {
  .crystal-icon-huge {
    font-size: 6rem;
  }
  
  .crystal-icon-large {
    font-size: 3rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/globals.css"],"names":[],"mappings":"AAAA,SAAS;;AAET;EACE,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;;EAEpB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;;EAEpB,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;;EAEnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;;EAEnB,SAAS;EACT,sCAAsC;EACtC,0CAA0C;EAC1C,+CAA+C;EAC/C,8BAA8B;;EAE9B,SAAS;EACT,+EAA+E;EAC/E,gFAAgF;EAChF,6EAA6E;EAC7E,4DAA4D;;EAE5D,OAAO;EACP,yFAAyF;;EAEzF,SAAS;EACT,0CAA0C;EAC1C,0CAA0C;EAC1C,2CAA2C;EAC3C,2CAA2C;;EAE3C,SAAS;EACT,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA,SAAS;AACT;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,qFAAqF;EACrF,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,6BAA6B;EAC7B,wCAAwC;EACxC,gDAAgD;EAChD,uCAAuC;EACvC,mBAAmB;EACnB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,sFAAsF;EACtF,UAAU;AACZ;;AAEA,SAAS;AACT;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,0CAA0C;EAC1C,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE,aAAa;AACf;;AAEA,UAAU;AACV;EACE,WAAW;EACX,0BAA0B;EAC1B,oCAAoC;EACpC,iCAAiC;EACjC,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,2CAA2C;EAC3C,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qCAAqC;EACrC,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,SAAS;AACT;EACE,eAAe;EACf,mCAAmC;EACnC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA,OAAO;AACP;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,gDAAgD;AAClD;;AAEA,UAAU;AACV;EACE;IACE,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* 全局样式 */\n\n:root {\n  /* 柠檬配色 */\n  --lemon-50: #fefce8;\n  --lemon-100: #fef9c3;\n  --lemon-200: #fef08a;\n  --lemon-300: #fde047;\n  --lemon-400: #facc15;\n  --lemon-500: #eab308;\n  --lemon-600: #ca8a04;\n  --lemon-700: #a16207;\n  --lemon-800: #854d0e;\n  --lemon-900: #713f12;\n\n  /* 芒果配色 */\n  --mango-50: #fff7ed;\n  --mango-100: #ffedd5;\n  --mango-200: #fed7aa;\n  --mango-300: #fdba74;\n  --mango-400: #fb923c;\n  --mango-500: #f97316;\n  --mango-600: #ea580c;\n  --mango-700: #c2410c;\n  --mango-800: #9a3412;\n  --mango-900: #7c2d12;\n\n  /* 绿叶素配色 */\n  --leaf-50: #f0fdf4;\n  --leaf-100: #dcfce7;\n  --leaf-200: #bbf7d0;\n  --leaf-300: #86efac;\n  --leaf-400: #4ade80;\n  --leaf-500: #22c55e;\n  --leaf-600: #16a34a;\n  --leaf-700: #15803d;\n  --leaf-800: #166534;\n  --leaf-900: #14532d;\n\n  /* 中性色 */\n  --gray-50: #f9fafb;\n  --gray-100: #f3f4f6;\n  --gray-200: #e5e7eb;\n  --gray-300: #d1d5db;\n  --gray-400: #9ca3af;\n  --gray-500: #6b7280;\n  --gray-600: #4b5563;\n  --gray-700: #374151;\n  --gray-800: #1f2937;\n  --gray-900: #111827;\n\n  /* 晶莹效果 */\n  --crystal-bg: rgba(255, 255, 255, 0.1);\n  --crystal-border: rgba(255, 255, 255, 0.2);\n  --crystal-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  --crystal-backdrop: blur(20px);\n  \n  /* 渐变效果 */\n  --gradient-primary: linear-gradient(135deg, var(--lemon-400), var(--mango-400));\n  --gradient-secondary: linear-gradient(135deg, var(--leaf-400), var(--lemon-300));\n  --gradient-success: linear-gradient(135deg, var(--leaf-500), var(--leaf-400));\n  --gradient-danger: linear-gradient(135deg, #ef4444, #dc2626);\n  \n  /* 字体 */\n  --font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  \n  /* 阴影层级 */\n  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);\n  --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.07);\n  --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.1);\n  --shadow-xl: 0 20px 25px rgba(0, 0, 0, 0.1);\n  \n  /* 动画时长 */\n  --duration-fast: 0.15s;\n  --duration-normal: 0.3s;\n  --duration-slow: 0.5s;\n}\n\n/* 基础重置 */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  font-size: 16px;\n}\n\nbody {\n  font-family: var(--font-family);\n  font-weight: 400;\n  line-height: 1.6;\n  color: var(--gray-800);\n  background: linear-gradient(135deg, var(--lemon-50), var(--mango-50), var(--leaf-50));\n  min-height: 100vh;\n  overflow-x: hidden;\n}\n\n/* 应用容器 */\n.app {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n/* 晶莹玻璃效果 */\n.glass-card {\n  background: var(--crystal-bg);\n  backdrop-filter: var(--crystal-backdrop);\n  -webkit-backdrop-filter: var(--crystal-backdrop);\n  border: 1px solid var(--crystal-border);\n  border-radius: 16px;\n  box-shadow: var(--crystal-shadow);\n  position: relative;\n  overflow: hidden;\n}\n\n.glass-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);\n  z-index: 1;\n}\n\n/* 按钮样式 */\n.crystal-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.875rem 1.5rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all var(--duration-normal) ease;\n  position: relative;\n  overflow: hidden;\n  text-decoration: none;\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  font-family: var(--font-family);\n}\n\n.crystal-btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);\n  transition: left var(--duration-slow) ease;\n  z-index: 1;\n}\n\n.crystal-btn:hover::before {\n  left: 100%;\n}\n\n.crystal-btn > * {\n  position: relative;\n  z-index: 2;\n}\n\n.crystal-btn.primary {\n  background: var(--gradient-primary);\n  color: white;\n  box-shadow: var(--shadow-md);\n}\n\n.crystal-btn.primary:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n}\n\n.crystal-btn.success {\n  background: var(--gradient-success);\n  color: white;\n  box-shadow: var(--shadow-md);\n}\n\n.crystal-btn.success:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n}\n\n.crystal-btn.danger {\n  background: var(--gradient-danger);\n  color: white;\n  box-shadow: var(--shadow-md);\n}\n\n.crystal-btn.danger:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n}\n\n.crystal-btn.large {\n  padding: 1.25rem 2rem;\n  font-size: 1.125rem;\n  font-weight: 700;\n}\n\n.crystal-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none !important;\n  box-shadow: var(--shadow-sm) !important;\n}\n\n.crystal-btn:disabled::before {\n  display: none;\n}\n\n/* 输入框样式 */\n.crystal-input {\n  width: 100%;\n  padding: 0.875rem 1.125rem;\n  background: rgba(255, 255, 255, 0.8);\n  border: 2px solid var(--gray-200);\n  border-radius: 12px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--gray-800);\n  transition: all var(--duration-normal) ease;\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  font-family: var(--font-family);\n}\n\n.crystal-input:focus {\n  outline: none;\n  border-color: var(--lemon-400);\n  background: rgba(255, 255, 255, 0.95);\n  box-shadow: 0 0 0 3px rgba(250, 204, 21, 0.1);\n  transform: translateY(-1px);\n}\n\n.crystal-input::placeholder {\n  color: var(--gray-500);\n}\n\n/* 水晶图标 */\n.crystal-icon {\n  font-size: 2rem;\n  background: var(--gradient-primary);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));\n}\n\n.crystal-icon-large {\n  font-size: 4rem;\n  background: var(--gradient-secondary);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));\n}\n\n.crystal-icon-huge {\n  font-size: 8rem;\n  background: var(--gradient-primary);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  filter: drop-shadow(0 8px 16px rgba(0, 0, 0, 0.1));\n}\n\n/* 动画 */\n@keyframes fadeIn {\n  0% { \n    opacity: 0; \n    transform: translateY(20px); \n  }\n  100% { \n    opacity: 1; \n    transform: translateY(0); \n  }\n}\n\n@keyframes slideInUp {\n  0% {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes pulse {\n  0%, 100% { \n    opacity: 1; \n  }\n  50% { \n    opacity: 0.5; \n  }\n}\n\n.fade-in {\n  animation: fadeIn var(--duration-normal) ease;\n}\n\n.slide-in-up {\n  animation: slideInUp var(--duration-normal) ease;\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .crystal-btn {\n    padding: 0.75rem 1.25rem;\n    font-size: 0.8125rem;\n  }\n  \n  .crystal-btn.large {\n    padding: 1rem 1.5rem;\n    font-size: 1rem;\n  }\n  \n  .crystal-input {\n    padding: 0.75rem 1rem;\n    font-size: 0.8125rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .crystal-icon-huge {\n    font-size: 6rem;\n  }\n  \n  .crystal-icon-large {\n    font-size: 3rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
